import { Regions } from '@wicadu/langscope'

import globalTranslations from '@translations/pages/items/manage-items-media/global'

export const MANAGE_ITEMS_MEDIA_TRANSLATIONS = {
  [Regions.Global]: globalTranslations,
} as const
